import { combineReducers } from 'redux';

import { routerReducer } from 'react-router-redux';

import geofence from './Geofence/reducers';
import accounts from './Auth/reducers';
import shared from './shared/reducers';
import POI from './POI/reducers';
import events from './Events/reducers';

// Route related reducers

const AppReducers = combineReducers({
  router: routerReducer,
  geofence,
  accounts,
  shared,
  POI,
  events,
});

export default AppReducers;


// WEBPACK FOOTER //
// ./src/rootReducer.js